function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import initialState from "./initialState";
import { LOG_ERROR } from "../actions";
export default function loading() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.loading, action = arguments.length > 1 ? arguments[1] : void 0;
    var match = action.type.match(/^(.+)_(BEGIN|SUCCESS|CANCELLED)$/);
    if (match) {
        var _match = _slicedToArray(match, 3), p = _match[1], type = _match[2];
        var prop = p === null || p === void 0 ? void 0 : p.toLowerCase();
        var exists = prop ? state.indexOf(prop) > -1 : false;
        if (type === "BEGIN" && !exists && prop) {
            var nState = state.slice();
            nState.push(prop);
            return nState;
        } else if (exists && (type === "SUCCESS" || type === "CANCELLED") && prop) {
            var index = state.indexOf(prop);
            var nState1 = state.slice();
            nState1.splice(index, 1);
            return nState1;
        } else {
            return state;
        }
    } else {
        if (action.type === LOG_ERROR && state.indexOf(action.key) > -1) {
            var index1 = state.indexOf(action.key);
            var nState2 = state.slice();
            nState2.splice(index1, 1);
            return nState2;
        } else {
            return state;
        }
    }
}
